import React from "react";
import { ShieldCheck, Award, HeartHandshake, Store } from "lucide-react";
import { BUSINESS } from "@/data/business";

const POINTS = [
  {
    icon: <Award className="h-5 w-5" />,
    title: "Authorised dealer",
    text: "Products from authorised distributors of top brands — 100% genuine with full manufacturer warranty.",
  },
  {
    icon: <ShieldCheck className="h-5 w-5" />,
    title: "GST-registered store",
    text: "Proper invoices for every purchase. GSTIN — 10BZDPB2001B2ZU. Trusted by families across Fatehpur.",
  },
  {
    icon: <HeartHandshake className="h-5 w-5" />,
    title: "After-sales support",
    text: "Doorstep delivery, installation help and prompt service assistance for every product we sell.",
  },
  {
    icon: <Store className="h-5 w-5" />,
    title: "Visit our showroom",
    text: "Explore products in person near Railway Station, Fatehpur (opp. Devi Asthan), Gaya, Bihar.",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-white py-16 md:py-24" data-testid="about-section">
      <div className="container-b grid grid-cols-1 gap-12 lg:grid-cols-5 lg:gap-16">
        <div className="lg:col-span-2">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700">About Us</div>
          <h2 className="font-heading mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Your neighbourhood electronics store — since day one.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            {BUSINESS.name} is a family-run retail store in Fatehpur, Gaya, serving customers with
            honest pricing, genuine products and personal service. Whether you&apos;re setting up a new
            home or upgrading a single appliance, we&apos;re here to help you choose right.
          </p>

          <dl className="mt-8 grid grid-cols-2 gap-6">
            <div>
              <dt className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Store name</dt>
              <dd className="mt-1.5 font-heading text-base font-semibold text-slate-900">Bhadani Electronics</dd>
            </div>
            <div>
              <dt className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">GST No.</dt>
              <dd className="mt-1.5 font-mono text-sm font-semibold text-slate-900" data-testid="about-gst">
                10BZDPB2001B2ZU
              </dd>
            </div>
            <div>
              <dt className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Service line</dt>
              <dd className="mt-1.5 font-semibold text-slate-900">{BUSINESS.phone}</dd>
            </div>
            <div>
              <dt className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Email</dt>
              <dd className="mt-1.5 break-all text-sm font-semibold text-slate-900">{BUSINESS.email}</dd>
            </div>
          </dl>
        </div>

        <div className="lg:col-span-3">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {POINTS.map((p, i) => (
              <div
                key={p.title}
                className="lift rounded-2xl border border-slate-200 bg-slate-50 p-5"
                data-testid={`about-point-${i}`}
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-blue-700 text-white">
                  {p.icon}
                </span>
                <div className="font-heading mt-4 text-lg font-bold text-slate-900">{p.title}</div>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
